import {hostByBrandByEnv} from '../../../../../hosts'
import {CSP} from '../../../../constants'
import type {Preset} from '../../../../types'

export const AVATARS = {
  [CSP.IMG]: [hostByBrandByEnv.yandexcom.testing.avatars],
} as const satisfies Preset
